// actions
const SET = "cardCodes/SET";
const SET_ALL_LISTING = "cardCodes/SET_ALL_LISTING";
const SET_SELECTED = "cardCodes/SET_SELECTED";
const SET_SEARCH_TEXT = "cardCodes/SET_SEARCH_TEXT";
const SET_SEARCHING = "cardCodes/SET_SEARCHING";

const SET_LAST_INDEX = "cardCodes/SET_LAST_INDEX";
const SET_NEXT_TOKEN = "cardCodes/SET_NEXT_TOKEN";
const SET_PAGINATION = "cardCodes/SET_PAGINATION";

const SET_FILTERS = "cardCodes/SET_FILTERS";

const DEFAULT_STATE = {
  searchText: "",
  selected: "",
  isSearching: false,

  pagination: [],
  nextToken: null,
  lastIndex: null,

  listing: [],
  allListing: [],
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });
    case SET_ALL_LISTING:
      return Object.assign({}, state, { allListing: action.allListing });

    case SET_SEARCH_TEXT:
      return Object.assign({}, state, { searchText: action.searchText });
    case SET_SEARCHING:
      return Object.assign({}, state, { isSearching: action.payload });

    case SET_PAGINATION:
      return Object.assign({}, state, { pagination: action.pagination });
    case SET_NEXT_TOKEN:
      return Object.assign({}, state, { nextToken: action.id });
    case SET_LAST_INDEX:
      return Object.assign({}, state, { lastIndex: action.id });

    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setAllListing = (allListing: any[]) => ({
  allListing,
  type: SET_ALL_LISTING,
});

export const setSelected = (id: string) => ({ id, type: SET_SELECTED });
export const setSearchText = (searchText: string) => ({
  searchText,
  type: SET_SEARCH_TEXT,
});
export const setIsSearching = (payload: boolean) => ({
  payload,
  type: SET_SEARCHING,
});

export const setPagination = (pagination: any[]) => ({
  pagination,
  type: SET_PAGINATION,
});
export const setNextToken = (id: any) => ({ id, type: SET_NEXT_TOKEN });
export const setLastIndex = (id: number) => ({ id, type: SET_LAST_INDEX });
